import { combineReducers } from 'redux'
import filter from './filter'
import status from './status'
import customDeadline from './customDeadline'
import rejectOrder from './rejectOrder'

export default combineReducers({
  filter,
  status,
  customDeadline,
  rejectOrder,
})
